import { useAppSelector } from "redux/hooks";
import { getFormations } from "redux/slices/formationsSlice";
import { Formation } from "types";

type RowObj = Formation & { actions: any };

const useTableDataComplex = () => {
  return useAppSelector(getFormations)
    .formations.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (item) =>
            item.title === value.title && item.description === value.description
        )
    )
    .map((item) => {
      return { ...item, actions: null };
    });
};
export default useTableDataComplex;
